module.exports = __webpack_public_path__ + "fonts/fa-solid-900.b70cea03.ttf";